// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
import { APIResource } from "../../core/resource.mjs";
import { ArrayPage } from "../../core/pagination.mjs";
import { path } from "../../internal/utils/path.mjs";
export class Steps extends APIResource {
    /**
     * Get steps associated with a run with filtering options.
     */
    list(runID, query = {}, options) {
        return this._client.getAPIList(path `/v1/runs/${runID}/steps`, (ArrayPage), {
            query,
            ...options,
        });
    }
}
//# sourceMappingURL=steps.mjs.map